import { InspectionItem } from './inspection.type';

export enum NonServicePeriodTypeEnum {
  Break,
  PostTrip,
  PreTrip,
}

export enum NonServicePeriodActionEnum {
  End,
  Start,
}

export type NonServicePeriod = {
  hasBeenCompleted?: boolean;
  hasBeenStarted: boolean;
  inspectionItems?: InspectionItem[];
  inThePast?: boolean;
  isLastItem?: boolean;
  nonServicePeriodType: NonServicePeriodTypeEnum
  scheduledEnd: Date;
  scheduledStart: Date;
  timeToStop?: string;
  sequence?: number | null;
  inspectionFailureMessage?: string;
}
